module.exports = __webpack_public_path__ + "static/img/equ3.1d17191c.png";